// extracted by mini-css-extract-plugin
module.exports = {"container":"error_container__3amuA","header":"error_header__2u3Di","header2":"error_header2__1MbKh"};